import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'boma-no-results',
  templateUrl: './boma-no-results.component.html',
  styleUrls: ['./boma-no-results.component.scss'],
})
export class BomaNoResultsComponent implements OnInit {
  @Input() resultMessage = 'There were no results.';
  @Input() resultDescription =
    'Please change the search requirements and try again.';
  @Input() animationSize = 150;
  @Input() animationPath = '/assets/lottie/no-results.json';

  constructor() {}

  ngOnInit(): void {}
}
